// extracted by mini-css-extract-plugin
export default {"wrapper":"M7qmk","item":"FkwMx","icon":"wuZrR","fixed":"XvnZq","list":"oVkp5","iconWrapper":"wOtOs","iconShowroom":"qkDcD","iconBasket":"YgUYh","count":"O9Bp6","full":"j6NZp"};